export enum KeyboardNormalTypingKeysTypes {
  A='a',
  B='b',
  C='c',
  D='d',
  E='e',
  F='f',
  G='g',
  H='h',
  I='i',
  J='j',
  K='k',
  L='l',
  M='m',
  N='n',
  O='o',
  P='p',
  Q='q',
  R='r',
  S='s',
  T='t',
  U='u',
  V='v',
  W='w',
  X='x',
  Y='y',
  Z='z',
  CapA='A',
  CapB='B',
  CapC='C',
  CapD='D',
  CapE='E',
  CapF='F',
  CapG='G',
  CapH='H',
  CapI='I',
  CapJ='J',
  CapK='K',
  CapL='L',
  CapM='M',
  CapN='N',
  CapO='O',
  CapP='P',
  CapQ='Q',
  CapR='R',
  CapS='S',
  CapT='T',
  CapU='U',
  CapV='V',
  CapW='W',
  CapX='X',
  CapY='Y',
  CapZ='Z',
}
export enum KeyboardSpecialTypingKeyTypes {
  BracketLeft='[',
  BracketRight=']',
  Backquote='`',
  Special='~',
  ExclamationPoint='!',
  AtSign='@',
  Hash='#',
  Dollar='$',
  Percent='%',
  Caret='^',
  Ampersand='&',
  Asterisk='*',
  ParenthesisLeft='(',
  ParenthesisRight=')',
  Underscore='_',
  Plus='+',
  Pipe='|',
  CurlyBraceLeft='{',
  CurlyBraceRight='}',
  Semicolon=';',
  Quote="'",
  Comma=',',
  Period='.',
  Minus='-',
  Equal='=',
  LessThan='<',
  GreaterThan='>',
  QuestionMark='?',
  Colon=':',
  Space=' ',
  Digit0='0',
  Digit1='1',
  Digit2='2',
  Digit3='3',
  Digit4='4',
  Digit5='5',
  Digit6='6',
  Digit7='7',
  Digit8='8',
  Digit9='9',
  Backspace='Backspace',
}
